<template>
  <v-container>
    <v-card>
      <v-card-text>
        <v-form ref="actionForm">
          <v-row>
            <v-col cols="12" sm="6">
              <ActionFieldContainer :label="$t('keywords.name')" :description="$t('workflow.action.description.name')">
                <v-text-field
                  name="actionName"
                  label=""
                  v-model="nextAction.actionName"
                  :rules="alphaNumericRules(nextAction.actionName)"
                />
              </ActionFieldContainer>
            </v-col>
            <v-col cols="12" sm="6">
              <ActionFieldContainer :label="$t('workflow.action.title')">
                <v-autocomplete
                  label=""
                  name="actionType"
                  :items="translatedActions"
                  item-value="className"
                  item-text="fullDescription"
                  v-model="nextAction.actionType"
                  @change="findFields"
                  :rules="requiredRules(nextAction.actionType)"
                />
              </ActionFieldContainer>
            </v-col>

            <v-col cols="6" sm="6">
              <ActionFieldContainer :label="$t('workflow.action.label.disable_action')" :description="$t('workflow.action.description.disable_action')">
                <v-switch label="" v-model="nextAction.disableAction" />
              </ActionFieldContainer>
            </v-col>

            <v-col cols="6" sm="6">
              <ActionFieldContainer label="Desabilitar Logs" description="Desabilita os logs desta action">
                <v-switch
                name="disableLogs"
                label=""
                v-model="nextAction.disableLogs"
                />
              </ActionFieldContainer>
            </v-col>

            <v-col cols="12" sm="12">
              <ActionFieldContainer :label="$t('keywords.description')">
                <v-text-field
                label=""
                name="actionDescription"
                v-model="nextAction.actionDescription"
              />
              </ActionFieldContainer>
            </v-col>
            <v-col cols="12" sm="12" v-for="field in fieldsToMount" :key="field.name">
              <ActionFieldContainer :label="field.label" :description="field.description" v-if="field.type !== 'action'">
                <v-text-field
                label=""
                :name="field.name"
                v-if="field.type === 'string'"
                v-model="nextAction[field.name]"
                :rules="field.required ? requiredRules(nextAction[field.name], field.required) : []"
              />
              <DatabaseSelect
                label=""
                :name="field.name"
                v-if="field.type === 'database'"
                v-model="nextAction[field.name]"
                :required="field.required"
              />
              <SQLFormatter
                label=""
                :name="field.name"
                v-if="field.type === 'sql'"
                v-model="nextAction[field.name]"
                :required="field.required"
              />
              <v-autocomplete
                label=""
                :name="field.name"
                v-if="field.type === 'returntype'"
                item-value="model"
                item-text="label"
                :hint="field.classOfType"
                persistent-hint
                :items="avaliableActions.actions"
                v-model="nextAction[field.name]"
                :rules="field.required ? requiredRules(nextAction[field.name]) : []"
              />
              <CredentialSelect
                label=""
                :name="field.name"
                v-if="field.type === 'credential'"
                v-model="nextAction[field.name]"
                :type="field.classOfType"
                :required="field.required"
              />
              <AuthenticationSelect
                label=""
                :name="field.name"
                v-if="field.type === 'autenticationtype'"
                v-model="nextAction[field.name]"
                :rules="field.required ? requiredRules(nextAction[field.name]) : []"
              />
              <ParameterSelect
                label=""
                :name="field.name"
                v-if="field.type === 'parameter'"
                v-model="nextAction[field.name]"
                :required="field.required"
              />
              <FromToSelect
                label=""
                :name="field.name"
                v-if="field.type === 'fromtocollection'"
                v-model="nextAction[field.name]"
                :required="field.required"
              />
              <v-switch
                label=""
                :name="field.name"
                v-if="field.type === 'boolean'"
                v-model="nextAction[field.name]"
              />
              <BeanSelect
                label=""
                :name="field.name"
                v-if="field.type === 'bean' "
                v-model="nextAction[field.name]"
                classtype="br.com.senior.plutaoapp.utils.process.AuthenticationExecutor"
                :required="field.required"
              />
              <List
                label=""
                :name="field.name"
                v-if="field.type === 'List' || field.type === 'list'"
                v-model="nextAction[field.name]"
                :required="field.required"
              />
              <XMLFormatter
                label=""
                :name="field.name"
                v-if="field.type === 'xml'"
                v-model="nextAction[field.name]"
                :rules="field.required ? requiredRules(nextAction[field.name]) : []"
              />
              <HttpMethodSelect
                label=""
                :name="field.name"
                v-if="field.type === 'httpmethod'"
                v-model="nextAction[field.name]"
                :required="field.required"
              />
              <EmailServerSelect
                label=""
                :name="field.name"
                v-if="field.type === 'emailserver'"
                v-model="nextAction[field.name]"
                :required="field.required"
              />
              <RichTextEditor
                label=""
                :name="field.name"
                v-if="field.type === 'richtext'"
                v-model="nextAction[field.name]"
                :required="field.required"
              />
              <v-textarea
                label=""
                outlined
                :name="field.name"
                v-if="field.type === 'textarea'"
                v-model="nextAction[field.name]"
                :rules="field.required ? requiredRules(nextAction[field.name], field.required) : []"
              />
              <ValidationsSelect
                label=""
                :name="field.name"
                v-if="field.type === 'validation'"
                v-model="nextAction[field.name]"
                :required="field.required"
              />
              <DateOperationsSelect
                label=""
                :name="field.name"
                v-if="field.type === 'date-operations'"
                v-model="nextAction[field.name]"
                :required="field.required"
              />
              <SocketServerSelect
                label=""
                :name="field.name"
                v-if="field.type === 'socket-server'"
                v-model="nextAction[field.name]"
                :required="field.required"
              />

              </ActionFieldContainer>
              <ReplaceInfo
                v-if="field.showReplaceStringAlert"
                url-parameter
                body-property
                action-property
                action-value
                last-return
                for-value
                for-map-key
                for-index
                web-service-status
              />
            </v-col>

          </v-row>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="cancelClick">{{ $t('button.close') }}</v-btn>
        <v-btn color="blue darken-1" text @click="saveClick">{{ $t('button.save') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import workflowService from '@/services/WorkflowService'

import DatabaseSelect from '../core/DatabaseSelect'
import SQLFormatter from '../core/SQLFormatter'
import CredentialSelect from '../core/CredentialSelect'
import ParameterSelect from '../core/ParameterSelect'
import FromToSelect from '../core/CollectionsSelect'
import HttpMethodSelect from '../core/HttpMethodSelect'
import BeanSelect from '../core/BeanSelect'
import ValidationsSelect from '../core/ValidationsSelect'
import DateOperationsSelect from '../core/DateOperationsSelect'
import List from '../core/List'
import XMLFormatter from '../core/XMLFormatter'
import EmailServerSelect from '../core/EmailServerSelect'
import SocketServerSelect from '../core/SocketServerSelect'
import RichTextEditor from '../core/RichTextEditor'
import ActionFieldContainer from '../core/ActionFieldContainer'
import { alphaNumericRules, dangerousCodeInputApiRules, requiredRules } from '../../utils/rules'
import { mapMutations, mapState } from 'vuex'
import AuthenticationSelect from '../core/AuthenticationSelect.vue'
import ReplaceInfo from '../core/ReplaceInfo.vue'

export default {
  name: 'Action',

  computed: {
    ...mapState(['avaliableActions']),
    version () { return this.$versionable.versions.workflow },
    fieldsToMount () {
      return this.fields
        .filter(field => field.type !== 'bean' || this.version <= '1.0.0')
    },
    translatedActions () {
      return this.actions
        .map(action => {
          const className = action.className.toString().split('.').pop()
          const fullDescription = `${className} - ${this.$t(`actions_description.${className}`)}`

          return { ...action, fullDescription }
        })
    }
  },

  components: {
    ActionFieldContainer,
    DatabaseSelect,
    SQLFormatter,
    CredentialSelect,
    ParameterSelect,
    FromToSelect,
    BeanSelect,
    List,
    HttpMethodSelect,
    EmailServerSelect,
    ValidationsSelect,
    DateOperationsSelect,
    XMLFormatter,
    RichTextEditor,
    SocketServerSelect,
    AuthenticationSelect,
    ReplaceInfo
  },

  model: {
    prop: 'nextAction',
    event: 'change'
  },

  props: {
    info: {
      type: Object,
      default: () => {}
    },

    nextAction: {
      type: Object,
      default: () => {}
    },

    dialogVisible: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    alphaNumericRules,
    requiredRules,
    dangerousCodeInputApiRules,
    fields: [],
    valid: false,
    actions: [
      // {
      //   description: '',
      //   classname: '',
      //   fullDescription: ''
      // }
    ]
  }),

  mounted () {
    this.loadActions()
  },

  methods: {
    ...mapMutations(['addAction', 'remove']),

    cancelClick () {
      this.fields = []
      this.$emit('cancelClick')
    },

    saveClick () {
      if (this.$refs.actionForm.validate()) {
        workflowService
          .findByActionClassname(this.nextAction.actionType)
          .then((response) => {
            const payload = {
              name: this.nextAction.actionName,
              type: response.data.returnType
            }
            this.addAction(payload)
            this.fields = []
            this.$emit('saveClick')
          })
          .catch((error) => {
            alert(`${this.$t('warnings.error.occurred')} : ${error}`)
          })
      }
    },

    exists (name) {
      this.avaliableActions.actions.map((el) => {
        if (el.model === name) {
          this.remove(this.nextAction)
        }
      })
    },

    findFields () {
      const action = this.actions.find((e) => e.className === this.nextAction.actionType)
      if (!action) return

      workflowService.findActionByDescription(action.description)
        .then((response) => {
          this.fields = response.data.fields
        })
    },

    loadActions () {
      workflowService
        .findAllActions()
        .then((response) => {
          this.actions = response.data
          if (this.nextAction.actionType) { this.findFields() }
        })
        .catch((error) => {
          alert(`${this.$t('warnings.error.occurred')} maria : ${error}`)
        })
    },

    actionsName () {
      if (this.nextAction.actionName && this.nextAction.actionType) {
        this.$emit(
          'actionsName',
          this.nextAction.actionName,
          this.nextAction.actionType
        )
      }
    },

    removeAction (index) {
      this.remove(this.nextAction.actions[index])
      this.nextAction.actions.splice(index, 1)
    },

    addEmptyAction () {
      this.$emit('addSideAction', this.nextAction)
    },
    $war: key => this.$t('keywords.replace.' + key)
  },

  watch: {
    dialogVisible: function (value) {
      if (value && this.fields.length === 0) {
        this.loadActions()
      }
    }
  }
}
</script>

<style>
.button-right {
  float: right;
  margin-bottom: -15px;
}
</style>
